import type { World } from '../ecs/world'
import { makeEnemy } from '../entities/templates'
import { PALETTE } from '../render/palette'

/**
 * Assemblers (monster generators): continuously emit their enemy type until
 * destroyed. Destroying them is the real objective of a floor. Foremen boost
 * output of generators inside their aura.
 */
export function generatorSystem(world: World, dt: number): void {
  // reset boosts, then apply foreman auras
  const gens = world.generators()
  for (const g of gens) g.gen!.boost = 1
  for (const f of world.entities) {
    if (f.dead || f.etype !== 'foreman' || f.spawnT > 0) continue
    const cfg = world.tuning.enemies.foreman
    for (const g of gens) {
      if ((g.x - f.x) ** 2 + (g.y - f.y) ** 2 <= cfg.auraRadius ** 2) {
        g.gen!.boost = cfg.spawnRateMultiplier
      }
    }
  }

  for (const g of gens) {
    const gs = g.gen!
    if (gs.budget <= 0) continue
    gs.t -= dt * gs.boost
    if (gs.t > 0) continue
    gs.t = gs.interval * world.floorMods.generatorIntervalMul // SURPLUS runs the lines hot
    if (world.aliveChildrenOf(g.id) >= gs.aliveCap) continue
    // spawn adjacent to the generator, offset toward the player slightly
    const p = world.nearestPlayer(g.x, g.y)
    const ang = p ? Math.atan2(p.y - g.y, p.x - g.x) + world.levelRng.range(-0.9, 0.9) : world.levelRng.range(0, Math.PI * 2)
    const dist = g.radius + 14
    const child = makeEnemy(world.tuning, gs.genType, g.x + Math.cos(ang) * dist, g.y + Math.sin(ang) * dist, g.id, world.level.band)
    world.add(child)
    world.burst(g.x, g.y, PALETTE.generatorCore, 5, 90, 0.4, 2)
    gs.budget -= 1
  }
}
